import * as vueToastification from "vue-toastification";

const { useToast: useVueToastification } =
  "useToast" in (vueToastification as object)
    ? vueToastification
    : (vueToastification.default as unknown as typeof vueToastification);

export const useToast: typeof useVueToastification = (...params) => {
  return useVueToastification(...params);
};
